/**
 * Step 6: Allergies & Intolerances
 */
import React from 'react';
import { AlertCircle, X, Plus } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

const COMMON_INTOLERANCES = [
  { id: 'lactose', label: 'Laktoseintoleranz' },
  { id: 'gluten', label: 'Glutenunverträglichkeit' },
  { id: 'fructose', label: 'Fruktoseintoleranz' },
  { id: 'histamin', label: 'Histaminintoleranz' },
];

const COMMON_ALLERGIES = [
  'Nüsse', 'Erdnüsse', 'Soja', 'Eier', 'Milch', 'Weizen', 
  'Fisch', 'Meeresfrüchte', 'Sesam', 'Sellerie', 'Senf'
];

const StepAllergies = ({ 
  prefs, 
  setPrefs, 
  newAvoidFood, 
  setNewAvoidFood,
  addAvoidFood,
  removeAvoidFood,
  toggleIntolerance
}) => {
  return (
    <div className="space-y-4" data-testid="onboarding-step-allergies">
      <div className="text-center mb-6">
        <AlertCircle className="w-12 h-12 text-orange-500 mx-auto mb-3" />
        <h3 className="text-xl font-bold text-white">Allergien & Unverträglichkeiten</h3>
        <p className="text-zinc-400 text-sm">Diese werden bei allen Vorschlägen berücksichtigt</p>
      </div>
      
      {/* Intolerances */}
      <div>
        <Label className="text-white mb-2 block text-sm">Unverträglichkeiten</Label>
        <div className="grid grid-cols-2 gap-2">
          {COMMON_INTOLERANCES.map(intol => (
            <button
              key={intol.id}
              onClick={() => toggleIntolerance(intol.id)}
              className={`p-3 rounded-lg border-2 text-left transition-all ${
                prefs.intolerances.includes(intol.id)
                  ? 'border-orange-500 bg-orange-500/10'
                  : 'border-zinc-700 hover:border-zinc-600 bg-zinc-800/50'
              }`}
            >
              <p className="text-sm text-white">{intol.label}</p>
            </button>
          ))}
        </div>
      </div>
      
      {/* Allergies */}
      <div>
        <Label className="text-white mb-2 block text-sm">Allergien / Vermeiden</Label>
        <div className="flex flex-wrap gap-2 mb-2">
          {prefs.avoid_foods.map(food => (
            <Badge key={food} variant="destructive" className="gap-1 bg-red-500/20 text-red-400">
              {food}
              <X className="w-3 h-3 cursor-pointer" onClick={() => removeAvoidFood(food)} />
            </Badge>
          ))}
        </div>
        <div className="flex flex-wrap gap-1 mb-2">
          {COMMON_ALLERGIES.filter(a => !prefs.avoid_foods.includes(a)).map(allergy => (
            <Badge 
              key={allergy} 
              variant="outline" 
              className="cursor-pointer hover:bg-red-500/20 border-zinc-600 text-zinc-300 text-xs"
              onClick={() => addAvoidFood(allergy)}
            >
              + {allergy}
            </Badge>
          ))}
        </div>
        <div className="flex gap-2">
          <Input
            value={newAvoidFood}
            onChange={(e) => setNewAvoidFood(e.target.value)}
            placeholder="Anderes..."
            onKeyPress={(e) => e.key === 'Enter' && addAvoidFood(newAvoidFood)}
            className="bg-zinc-800 border-zinc-700 text-white text-sm"
          />
          <Button variant="outline" size="sm" onClick={() => addAvoidFood(newAvoidFood)} className="border-zinc-600">
            <Plus className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export { COMMON_INTOLERANCES, COMMON_ALLERGIES };
export default StepAllergies;
